import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'trailer',
  size: 24,
  node: [
    ['path', { d: 'M10 11.341V10', key: '1vu6ku' }],
    ['path', { d: 'M14 13v-3', key: 'ywspeg' }],
    ['path', { d: 'M18 17V8a2 2 0 00-2-2H4a2 2 0 00-2 2v7a2 2 0 002 2h2', key: '19481b' }],
    ['path', { d: 'M22 15v1a1 1 0 01-1 1H10', key: '1lvljf' }],
    ['path', { d: 'M6 11.341V10', key: '1dkezj' }],
    ['circle', { cx: '8', cy: '17', r: '2', key: '5kbc0u' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Trailer
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTEuMzQxVjEwIiAvPgogIDxwYXRoIGQ9Ik0xNCAxM3YtMyIgLz4KICA8cGF0aCBkPSJNMTggMTdWOGEyIDIgMCAwMC0yLTJINGEyIDIgMCAwMC0yIDJ2N2EyIDIgMCAwMDIgMmgyIiAvPgogIDxwYXRoIGQ9Ik0yMiAxNXYxYTEgMSAwIDAxLTEgMUgxMCIgLz4KICA8cGF0aCBkPSJNNiAxMS4zNDFWMTAiIC8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjE3IiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/trailer
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Trailer = createLucideIcon(__iconData);

export default Trailer;
